<template>
  <div class="invitation">
    <button type="button" class="invite-back" @click="onClickLeft" aria-label="返回">
      <van-icon name="arrow-left" />
    </button>
    <!--    <van-nav-bar-->
    <!--      :title="$t('m.syicon4')"-->
    <!--      @click-left="onClickLeft"-->
    <!--      left-arrow-->
    <!--    ></van-nav-bar>-->
    <div class="dd-main">
      <div class="invite-share-panel">
        <div class="yqm">
          <div class="invite-code-row">
            <div style="font-size: 20px">{{ $t("m.yq_span0") }}：</div>
            <div style=" font-size:26px;font-weight:bold;color:#FF3738;">
              {{ data.invite }}
            </div>
            <button type="button" class="copy" @click="copyText(data.invite)">
              复制
            </button>
          </div>
          <div class="recommend-link">
            <a :href="recommendationUrl">{{ recommendationUrl }}</a>
            <button
              type="button"
              class="copy-link"
              @click="copyText(recommendationUrl, '下载链接')"
            >
              复制下载链接
            </button>
          </div>
        </div>
        <div class="ercode">
          <img :src="qrCode" alt="应用下载二维码" />
        </div>
      </div>

      <div class="yqm1">
        <van-button
          :class="{ seled: type === 1 }"
          @click="tiaozhuan(1)"
          round="true"
          type="primary"
        >
          安卓下载
        </van-button>
        <div class="dd-div">
          <van-button
            :class="{ seled: type === 2 }"
            @click="tiaozhuan(2)"
            round="true"
            type="primary"
          >
            苹果下载一
          </van-button>
          <van-button
            :class="{ seled: type === 3 }"
            @click="tiaozhuan(3)"
            round="true"
            type="primary"
          >
            苹果下载二
          </van-button>
        </div>
        使用浏览器扫描二维码下载app
      </div>
      <div class="jjjs">
        <div class="jl1">
          <div class="jjjs-num">1</div>
          {{ $t("m.yq_span1") }} 10000*{{ data.l1 }}%=
          <span class="price">{{ 10000 * (data.l1 * 0.01) }}</span>
        </div>
        <div class="jl1">
          <div class="jjjs-num">2</div>
          {{ $t("m.yq_span2") }} 10000*{{ data.l2 }}%=
          <span class="price">{{ 10000 * (data.l2 * 0.01) }}</span>
        </div>
        <div class="jl1">
          <div class="jjjs-num">3</div>
          {{ $t("m.yq_span3") }} 10000*{{ data.l3 }}%=
          <span class="price">{{ 10000 * (data.l3 * 0.01) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHyDataInfo } from "@api/user";

const APP_DOWNLOAD_PAGE = "https://jjbsbzdkqvqzwt.top/";

export default {
  data() {
    return {
      data: {},
      qrCode: "",
      type: 1,
      selectedDownloadUrl: ""
    };
  },
  created() {
    this.getData();
  },
  computed: {
    recommendationUrl() {
      const invite = String((this.data && this.data.invite) || "").trim();
      if (!invite) {
        return APP_DOWNLOAD_PAGE;
      }
      return `${APP_DOWNLOAD_PAGE}?spread=${encodeURIComponent(invite)}`;
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getDownloadSource(index) {
      const fields = {
        1: "app_android_url",
        2: "app_ios_url1",
        3: "app_ios_url2"
      };
      const key = fields[index] || fields[1];
      return (this.data && this.data[key]) || "";
    },
    resolveDownloadUrl(value) {
      const text = String(value || "").trim();
      if (!text) {
        return "";
      }
      const match = text.match(/[?&]data=([^&]+)/i);
      if (/api\.qrserver\.com\/v1\/create-qr-code/i.test(text) && match) {
        try {
          return decodeURIComponent(match[1]);
        } catch (e) {
          return match[1];
        }
      }
      return text;
    },
    makeQrCode(value) {
      const text = String(value || "").trim();
      if (!text) {
        return "";
      }
      if (
        /^data:image\//i.test(text) ||
        /(\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$)|qr|qrcode|create-qr-code/i.test(text)
      ) {
        return text;
      }
      return (
        "https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=" +
        encodeURIComponent(text)
      );
    },
    tiaozhuan(index) {
      this.type = index;
      const url = this.recommendationUrl;
      this.selectedDownloadUrl = url;
      this.qrCode = this.makeQrCode(url);
      window.location.href = url;
    },
    getData() {
      getHyDataInfo().then(res => {
        this.data = res.data.data;
        this.selectedDownloadUrl = this.recommendationUrl;
        this.qrCode = this.makeQrCode(this.selectedDownloadUrl);
      });
    },
    //复制文本
    copyText(text, label) {
      if (!text) {
        this.$toast("暂无可复制内容");
        return;
      }
      var element = this.createElement(text);
      element.select();
      element.setSelectionRange(0, element.value.length);
      document.execCommand("copy");
      element.remove();
      this.$toast.success((label || "邀请码") + "复制成功");
    },
    //创建临时的输入框元素
    createElement(text) {
      var isRTL = document.documentElement.getAttribute("dir") === "rtl";
      var element = document.createElement("textarea");
      // 防止在ios中产生缩放效果
      element.style.fontSize = "12pt";
      // 重置盒模型
      element.style.border = "0";
      element.style.padding = "0";
      element.style.margin = "0";
      // 将元素移到屏幕外
      element.style.position = "absolute";
      element.style[isRTL ? "right" : "left"] = "-9999px";
      // 移动元素到页面底部
      let yPosition = window.pageYOffset || document.documentElement.scrollTop;
      element.style.top = `${yPosition}px`;
      //设置元素只读
      element.setAttribute("readonly", "");
      element.value = text;
      document.body.appendChild(element);
      return element;
    }
  }
};
</script>

<style lang="less">
.dd-main {
  width: 100%;
  height: 100vh;
  background: url("../../assets/images/img/img/yqpp.png") no-repeat;
  position: relative;
  background-size: 100% 100%;
}
.invitation {
  /* margin-top: -1rem; */
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  position: relative;
  z-index: 999;
}

.invite-back {
  position: fixed;
  top: calc(env(safe-area-inset-top) + 12px);
  left: 14px;
  z-index: 1001;
  width: 38px;
  height: 38px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.76);
  color: #5b3aa7;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 18px rgba(87, 38, 118, 0.2);
  backdrop-filter: blur(6px);

  .van-icon {
    font-size: 22px;
    font-weight: 700;
  }

  &:active {
    background: rgba(255, 255, 255, 0.92);
    transform: scale(0.96);
  }
}

.jjjs {
  position: absolute;
  top: 77vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-weight: 700;

  .jl1 {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .jjjs-num {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: #ffcc49;
    color: #fff;
    padding: 5px 8px;
    margin-right: 15px;
    font-size: 12px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.seled {
  background-color: #dadada !important;
}
.price {
  margin: 0 5px;
  font-size: 18px;
  color: red;
}

.invite-share-panel {
  position: absolute;
  top: 17vh;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.yqm {
  color: #666;
  width: 100%;
  text-align: center;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .invite-code-row {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .copy {
    border-radius: 20px;
    margin-left: 5px;
    padding: 2px 8px;
    color: #ffc107;
    font-size: 12px;
    vertical-align: middle;
    border: 2px solid #ffc107;
  }

  .recommend-link {
    display: flex;
    width: calc(100% - 48px);
    max-width: 390px;
    height: 34px;
    margin-top: 7px;
    padding-left: 12px;
    overflow: hidden;
    align-items: center;
    color: #59446f;
    font-size: 11px;
    text-align: left;
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(255, 193, 7, 0.55);
    border-radius: 17px;
    box-shadow: 0 5px 16px rgba(76, 36, 118, 0.12);

    a {
      min-width: 0;
      overflow: hidden;
      flex: 1;
      color: inherit;
      text-decoration: none;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .copy-link {
    height: 100%;
    padding: 0 13px;
    flex: 0 0 auto;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    border: 0;
    background: #ffb800;
  }
}

.yqm1 {
  position: absolute;
  font-size: 16px;
  top: 51vh;
  width: calc(100% - 0rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  color: #ffffff;

  .dd-div {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    button {
      width: 48%;
    }
  }

  button {
    width: 100%;
    margin-bottom: 10px;
  }
}

.yqm1 button {
  font-size: 16px;
  font-weight: bold;
  background: #ffcc49;
  height: 45px;
  color: #ffffff;
  border: 0px solid;
}

.ercode {
  width: clamp(128px, 18.5vh, 148px);
  height: clamp(128px, 18.5vh, 148px);
  margin-top: 12px;
  flex: 0 0 auto;
}

.ercode img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
}

@media (max-height: 640px) {
  .invite-share-panel {
    top: 14vh;
  }

  .ercode {
    width: 112px;
    height: 112px;
    margin-top: 10px;
  }

  .yqm1 {
    top: 50vh;
  }
}
</style>

